import React from "react";
import { useIntl } from "react-intl";
import { toTitleCase } from "../../utils/functions";
import { selectCategory } from "../../utils/Products/functions";
import { HiChevronRight } from "react-icons/hi2";
import ProductFilters from "../../components/Filters/ProductFilters";
import { List, ListItem, ListItemText, ListItemIcon } from "@mui/material";

const ProductFilterTab = ({
    selectedCategory,
    setRefreshing,
    productLevelOnes,
    setSelectedCategory,
    expandedLevels,
    setExpandedLevels,
    shownProducts,
    setShownProducts,
    selectedFilters,
    setSelectedFilters,
    subCategories,
    setSubCategories,
    allProducts,
    mobileFilterOpen,
    mobileFilters,
    setMobileFilters,
    setIsFilterOpen,
}) => {
    const intl = useIntl();
    return !selectedCategory ? (
        <>
            <div className="mx-2 w-full">
                <div className="font-semibold mb-3 text-left text-lg md:text-base">
                    {intl.formatMessage({ id: "category" })}
                </div>
                <List>
                    {productLevelOnes.sort().map((levelOne) => (
                        <ListItem
                            key={levelOne}
                            onClick={() =>
                                selectCategory(
                                    levelOne,
                                    setSelectedCategory,
                                    setRefreshing,
                                    setIsFilterOpen
                                )
                            }
                            sx={{
                                cursor: "pointer",
                                padding: "2px 0px",
                                "& .MuiListItemText-root .MuiTypography-root": {
                                    fontSize: {
                                        xs: "17px", // Mobile
                                        md: "15px", // Desktop (medium breakpoint and up)
                                    },
                                },
                                "& .MuiListItemIcon-root": {
                                    marginLeft: "8px",
                                },
                                "&:hover": {
                                    "& .MuiListItemText-root .MuiTypography-root":
                                        {
                                            fontSize: {
                                                xs: "17px", // Mobile
                                                md: "15px", // Desktop
                                            },
                                            color: "text.primary",
                                            fontWeight: 400,
                                        },
                                    "& .MuiListItemIcon-root": {
                                        color: "text.primary",
                                        transform: "scale(1.1)",
                                        marginLeft: "8px",
                                    },
                                },
                            }}
                        >
                            <ListItemText primary={toTitleCase(levelOne)} />
                            <ListItemIcon sx={{ minWidth: "24px" }}>
                                <HiChevronRight />
                            </ListItemIcon>
                        </ListItem>
                    ))}
                </List>
            </div>
        </>
    ) : (
        <ProductFilters
            category={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            expandedLevels={expandedLevels}
            setExpandedLevels={setExpandedLevels}
            shownProducts={shownProducts}
            setShownProducts={setShownProducts}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            subCategories={subCategories}
            setSubCategories={setSubCategories}
            allProducts={allProducts}
            mobileFilterOpen={mobileFilterOpen}
            mobileFilters={mobileFilters}
            setMobileFilters={setMobileFilters}
            setIsFilterOpen={setIsFilterOpen}
        />
    );
};
export default ProductFilterTab;
